import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { GetUsersThunk, ManageUser, resetManageUsersReducer } from '../../../../redux/slices/components/ManageUsers/manageUsersDataSlice'
import { RootState, useAppDispatch } from '../../../../redux/store/store'
import LoadingSpinner from '../../../LoadingSpinner'
import "./ContainerRowsTableUsers.css"
import RowTableUsers from './RowTableUsers/RowTableUsers'
import { useSearchParams } from 'react-router-dom'
import { canBeInteger } from '../../../../utils/verifications/strings'

const ContainerRowsTableUsers = () => {
 
    const dispatch = useAppDispatch()
    const [searchParams] = useSearchParams();

    const usersToShow = useSelector((state: RootState) => state.manageUsersData.usersToShow)
    const loadingContainer = useSelector((state: RootState) => state.manageUsersData.loadingContainer)
    const usersGrouped = useSelector((state: RootState) => state.manageUsersGroupedData.usersGrouped)

    useEffect(() => {
        return () => {
            dispatch(resetManageUsersReducer())
        }
    }, [])
        
    
    useEffect(() => {
            // Get a specific parameter value
        const limitParam = searchParams.get("limit") ?? "10"
        const pageParam = searchParams.get("page") ?? "1"

        let limit = 10
        if( canBeInteger(limitParam) )
            limit = Number(limitParam)
        
        let page = 1
        if( canBeInteger(pageParam) )
            page = Number(pageParam)

        dispatch(GetUsersThunk({ page, limit }))

    }, [searchParams.get("page"), searchParams.get("limit")])
    

    return (
        <div id={`container-rows-manage-users`} className="container-rows-table-users p-relative width-100 height-100 ff-roboto" >
            { loadingContainer && <LoadingSpinner fullPage={false} /> }
            <div className="aux-scroll">
                {
                    usersToShow.map((user: ManageUser) => {
                        const userGrouped = usersGrouped.some((userGrouped: ManageUser) => user.id === userGrouped.id)
                        return(
                            <RowTableUsers 
                                key={user.id} 
                                user={user} 
                                checkboxValue={userGrouped ? true : false}
                            />
                        )
                    })
                }
            </div> 
        </div>
    )
}

export default ContainerRowsTableUsers